(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hv24-customer-service"]) return;
  try {
    
for(const root of document.querySelectorAll('[data-customer-service]')){
  const $=s=>root.querySelector(s),form=$('[data-form]'),details=$('[data-details]'),review=$('[data-review-panel]'),error=$('[data-error-message]');
  let kind='',snapshot=null,key='',busy=false,unknown=false,finished=false;
  const newKey=()=>Array.from(crypto.getRandomValues(new Uint8Array(32)),v=>v.toString(16).padStart(2,'0')).join('');
  const focus=el=>{el.focus({preventScroll:true});el.scrollIntoView({behavior:'smooth',block:'center'});};
  const showError=message=>{error.textContent=message;error.hidden=false;error.scrollIntoView({behavior:'smooth',block:'nearest'});};
  const field=name=>form.elements.namedItem(name);
  function conditional(){const partial=field('scope').value==='PARTIAL';$('[data-items]').hidden=!partial;field('items').required=partial;field('contract').required=!field('orderNumber').value.trim();field('contract').minLength=field('contract').required?5:0;}
  function choose(next,scroll=true){if(busy||unknown)return;if(finished){form.reset();finished=false;form.hidden=false;$('[data-success]').hidden=true;}kind=next;snapshot=null;key=newKey();details.hidden=false;review.hidden=true;error.hidden=true;$('[data-workspace]').hidden=false;$('[data-form-title]').textContent=kind==='WITHDRAWAL'?root.dataset.withdrawal:root.dataset.defect;$('[data-photo-field]').hidden=kind!=='DEFECT';$('[data-withdrawal-hint]').hidden=kind!=='WITHDRAWAL';field('message').required=kind==='DEFECT';field('message').minLength=kind==='DEFECT'?5:0;const label=$('[data-message-label]');if(!label.dataset.original)label.dataset.original=label.textContent;label.textContent=kind==='DEFECT'?$('[data-defect-label]').textContent:label.dataset.original;for(const a of root.querySelectorAll('[data-kind]')){const selected=a.dataset.kind===kind;a.setAttribute('aria-current',String(selected));a.closest('.hv24-returns-choice')?.classList.toggle('is-selected',selected);}conditional();if(scroll)focus($('[data-form-title]'));}
  for(const a of root.querySelectorAll('[data-kind]'))a.addEventListener('click',event=>{event.preventDefault();if(busy||unknown)return;history.replaceState(null,'',a.getAttribute('href'));choose(a.dataset.kind);});
  form.addEventListener('input',conditional);
  const fileContent=file=>new Promise((resolve,reject)=>{const reader=new FileReader();reader.onload=()=>resolve(String(reader.result).split(',')[1]);reader.onerror=reject;reader.readAsDataURL(file);});
  form.addEventListener('submit',async event=>{event.preventDefault();if(!kind||busy||unknown||finished)return;conditional();if(!form.reportValidity())return;error.hidden=true;const files=kind==='DEFECT'?Array.from(field('photos').files):[];if(files.length>3||files.some(f=>f.size>2097152||!['image/jpeg','image/png','image/webp'].includes(f.type))){showError(root.dataset.photoError);return;}
    busy=true;try{snapshot={kind,name:field('name').value.trim(),email:field('email').value.trim(),orderNumber:field('orderNumber').value.trim(),contract:field('contract').value.trim(),scope:field('scope').value,items:field('scope').value==='PARTIAL'?field('items').value.trim():'',message:field('message').value.trim(),website:field('website').value,photos:await Promise.all(files.map(async f=>({name:f.name,mime:f.type,content:await fileContent(f)}))),confirmed:true,key};
    const summary=$('[data-summary]');summary.replaceChildren();const add=(label,value)=>{if(!value)return;const dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=label;dd.textContent=value;summary.append(dt,dd);};
    for(const name of ['name','email','orderNumber','contract','items','message'])add(form.querySelector('label[for="'+field(name).id+'"]').textContent,snapshot[name]);add(form.querySelector('legend').textContent,snapshot.scope==='ALL'?root.dataset.all:root.dataset.partial);if(files.length)add(form.querySelector('label[for="'+field('photos').id+'"]').textContent,files.map(f=>f.name).join(', '));
    $('[data-declaration-text]').hidden=kind!=='WITHDRAWAL';$('[data-declaration-text]').textContent=snapshot.scope==='PARTIAL'?root.dataset.partialDeclaration:root.dataset.declaration;$('[data-confirm]').textContent=kind==='WITHDRAWAL'?root.dataset.confirmWithdrawal:root.dataset.confirmDefect;details.hidden=true;review.hidden=false;focus($('[data-review-title]'));
    }catch{showError(root.dataset.photoError);}finally{busy=false;}
  });
  $('[data-edit]').addEventListener('click',()=>{if(busy||unknown)return;review.hidden=true;details.hidden=false;error.hidden=true;key=newKey();focus($('[data-form-title]'));});
  $('[data-confirm]').addEventListener('click',async()=>{if(!snapshot||busy||finished)return;busy=true;error.hidden=true;const button=$('[data-confirm]'),original=button.textContent;button.disabled=true;button.textContent=root.dataset.sending;$('[data-edit]').disabled=true;const controller=new AbortController(),timeout=setTimeout(()=>controller.abort(),25000);
    try{unknown=true;const response=await fetch(root.dataset.endpoint,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(snapshot),credentials:'omit',referrerPolicy:'no-referrer',signal:controller.signal});const data=await response.json();if(!response.ok){unknown=response.status>=500;throw new Error(data.error||root.dataset.error);}if(!/^CR-[a-f0-9]{32}$/.test(data.id))throw new Error(root.dataset.error);finished=true;unknown=false;form.hidden=true;$('[data-success]').hidden=false;$('[data-reference]').textContent=data.reference||data.id;$('[data-received]').textContent=new Date(data.receivedAt).toLocaleString(document.documentElement.lang||'de-DE',{timeZone:'Europe/Berlin'})+' (Berlin)';$('[data-download]').href=data.receiptUrl;if(data.photoWarning){$('[data-photo-warning-message]').textContent=root.dataset.photoWarning;$('[data-photo-warning-message]').hidden=false;}focus($('[data-success-title]'));
    }catch(e){if(e instanceof TypeError||e.name==='AbortError')unknown=true;showError(e.name==='AbortError'||e instanceof TypeError?root.dataset.error:e.message);}finally{clearTimeout(timeout);busy=false;button.disabled=false;button.textContent=original;$('[data-edit]').disabled=unknown;}
  });
  const fromHash=()=>{if(location.hash==='#widerruf')choose('WITHDRAWAL');else if(location.hash==='#reklamation')choose('DEFECT');};window.addEventListener('hashchange',fromHash);fromHash();
}

  } catch(e) { console.error(e); }
})();
})();
